// extracted by mini-css-extract-plugin
module.exports = {"select":"AntdSelect_select__3Kaxb","white":"AntdSelect_white__2i9tM","popup":"AntdSelect_popup__386ch"};